module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_decollte_suns-a1c2c602a385f3ebe9c982acc2fef7ee.svg";